import React from "react";

const AnalyticsInventory = () => {
  return (
    <div>
      <h3 className="text-lg font-bold">Templates</h3>
      <p>Analytics Content goes here.</p>
    </div>
  );
};

export default AnalyticsInventory;